import React, { useRef, useState } from "react";
import { Box, Button, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";

export default function StopQrCode({ stopId, organizationId, stopName }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const canvasContainerRef = useRef(null);
  const [copied, setCopied] = useState(false);

  if (!stopId || !organizationId) return null;

  const url = new URL(`/track/screen/${encodeURIComponent(stopId)}`, window.location.origin);
  url.searchParams.set("org", organizationId);
  url.searchParams.set("InfoSide", "right");
  const stopUrl = url.toString();

  const download = () => {
    const canvas = canvasContainerRef.current?.querySelector("canvas");
    if (!canvas) return;
    const link = document.createElement("a");
    link.download = `stop-${stopId}-qr.png`;
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(stopUrl);
      setCopied(true);
    } catch (error) {
      console.error("Could not copy stop link:", error);
    }
  };

  return (
    <Paper elevation={4} sx={{ position: "absolute", right: 16, bottom: 40, zIndex: 2, p: { xs: 0.5, md: 1 }, textAlign: "center", width: { xs: 80, md: "auto" }, maxWidth: 160 }}>
      <Typography variant="caption" sx={{ display: "block", fontWeight: 700, mb: 0.5 }}>
        {isMobile ? "Scan stop" : `Scan for ${stopName || `Stop ${stopId}`}`}
      </Typography>
      <Box ref={canvasContainerRef} sx={{ display: "flex", justifyContent: "center" }}>
        <QRCodeCanvas value={stopUrl} size={isMobile ? 64 : 112} marginSize={1} aria-label={`QR code for ${stopName || `Stop ${stopId}`}`} />
      </Box>
      {/* <Box sx={{ display: "flex", justifyContent: "center", mt: 0.5 }}>
        <Button size="small" onClick={copy}>{copied ? "Copied" : "Copy"}</Button>
        <Button size="small" onClick={download}>Save</Button>
      </Box> */}
    </Paper>
  );
}
